/**
 * @copyright Valor Software
 * @copyright Angular ng-bootstrap team
 */
export var ContentRef = (function () {
    function ContentRef(nodes, viewRef, componentRef) {
        this.nodes = nodes;
        this.viewRef = viewRef;
        this.componentRef = componentRef;
    }
    return ContentRef;
}());
//# sourceMappingURL=content-ref.class.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/component-loader/content-ref.class.js
// module id = ./node_modules/ngx-bootstrap/component-loader/content-ref.class.js
// module chunks = 4